import type { Icon } from '../../../src/lib/types'
export const mdiBookVariant: Icon = {
  "id": "book-variant",
  "name": "Book Variant",
  "path": "M6,4H11V12L8.5,10.5L6,12M18,2H6A2,2 0 0,0 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V4A2,2 0 0,0 18,2Z",
  "as": [
    "class"
  ],
  "tags": []
}
export default mdiBookVariant